import './AspectContainer.less';
import React, {useState, useEffect} from 'react';


export default function AspectContainer({
    children,
    ratio = null
}) {

    return <div className="aspect-container">
        <div
            className="aspect-ratio"
            style={{padding: ratio !== null ? `0 0 ${100 / ratio}% 0` : undefined}}
        >
            <div className="aspect-area">
                {children}
            </div>
        </div>
    </div>;
}
